export const ContentType = 'Content-Type'
export const FormData = 'multipart/form-data'
export const UrlEncoded = 'application/x-www-form-urlencoded'
export const TextPlain = 'text/plain'
export const ApplicationJson = 'application/json'
export const ApplicationXml = 'application/xml'
export const XML_MIME_TYPES = [
  'application/xhtml+xml',
  ApplicationXml,
]
export const PLAIN_MIME_TYPES = [
  'text/html',
  'text/xml',
  TextPlain,
]
export const COMMON_MIME_TYPES = [
  ApplicationJson,
  UrlEncoded,
  ...XML_MIME_TYPES,
  ...PLAIN_MIME_TYPES
];
export const REQUEST_HEADERS = [
  'Accept-Charset',
  'Accept-Encoding',
  'Accept-Language',
  'Accept',
  'Access-Control-Request-Headers',
  'Access-Control-Request-Method',
  'Authorization',
  'Cache-Control',
  'Connection',
  'Content-Language',
  ContentType,
  'Cookie',
  'Date',
  'DNT',
  'DPR',
  'Early-Data',
  'Expect',
  'Forwarded',
  'From',
  'Host',
  'If-Match',
  'If-Modified-Since',
  'If-None-Match',
  'If-Range',
  'If-Unmodified-Since',
  'Keep-Alive',
  'Max-Forwards',
  'Origin',
  'Pragma',
  'Proxy-Authorization',
  'Range',
  'Referer',
  'Save-Data',
  'TE',
  'Trailer',
  'Transfer-Encoding',
  'Upgrade-Insecure-Requests',
  'Upgrade',
  'User-Agent',
  'Vary',
  'Via',
  'Viewport-Width',
  'Warning',
  'Width',
];
export const REQUEST_HEADER_VALUES: Record<string, Array<string>> = {
  Accept: COMMON_MIME_TYPES,
  'Accept-Charset': [ 'utf-8', 'iso-8859-1' ],
  'Accept-Encoding': [ 'gzip', 'deflate' ],
  Authorization: [ 'Basic ', 'Bearer ', 'Digest ' ],
  'Cache-Control': [ 'no-cache' ],
  Connection: [ 'close', 'keep-alive' ],
  [ContentType]: [ ...COMMON_MIME_TYPES, FormData ],
};
